<div class="col-12">
    <div class="row align-items-center">
        <img src="./assets/icons/arrow.svg">
        <span class="section-title ml-2 mr-1">Minhas Recargas</span>
        <span (click)="pedidosList()" class="default-span ml-4">+ Ver mais</span>
    </div>

    <div class="column mt-5" [tourAnchor]="'4'" *ngIf="compraList.length < 1">
        <span class="action-call" >Faça sua primeira recarga!</span>
        <button (click)="novaCompra()" class="action-button mt-2">Vamos lá!</button>
    </div>

        <div class="row clickable main-block" *ngFor="let item of compraList" (click)="details(item)">
            <div class="col-6 col-sm-6 data">
                <span class="field-label">Valor Total:</span>
                <span class="field-value">{{(item.purchaseValue > 0) ? (item.purchaseValue | currency) : "R$ 0,00"}}</span>
            </div>
            <div class="col-6 col-sm-6 data">
                <span class="field-label">Data do crédito:</span>
                <span class="field-value">{{(item.releaseDate !== null) ? (item.releaseDate | date: 'dd/MM/yyyy') : "Não definida"}}</span>
            </div>
            <div class="line mt-2 mb-2"></div>
            <ng-container  *ngIf="item.products.length<3">
                <div class="col-4 col-sm-4 p-1 card-display" *ngFor="let produtos of item.products">
                    <app-svg-card [color]="produtos.productColor" [icon]="produtos.productIcon" [name]="produtos.productDescription"></app-svg-card>
                    <!--img [src]="'./assets/icons/produtos/icon-produtos/'+ produtos.productGuid +'.svg'"
                        onerror="this.src='./assets/icons/produtos/icon-produtos/SemImagem.svg';"
                        class="w-100 clickable"/>-->
                </div>
            </ng-container>
            <ng-container  *ngIf="item.products.length>=3">
                <ng-container  *ngFor="let produtos of item.products; let i=index">
                    <div class="col-4 col-sm-4 p-1 card-display" *ngIf="i<2">
                        <app-svg-card [color]="produtos.productColor" [icon]="produtos.productIcon" [name]="produtos.productDescription"></app-svg-card>
                        <!--img [src]="'./assets/icons/produtos/icon-produtos/'+ produtos.productGuid +'.svg'"
                            onerror="this.src='./assets/icons/produtos/icon-produtos/SemImagem.svg';"
                            class="w-100 clickable"/-->
                    </div>
                </ng-container>
                <div class="col-4 col-sm-4 p-2 d-flex justify-content-center" >
                    <h2><span class="badge badge-primary badge-recarga">+{{ item.products.length - 2 }}</span></h2>

                </div>
            </ng-container>
            <div class="col-12 mt-2">
                <div class="row justify-content-between">
                    <span [style.color]="statusColor(item)" class="status-label">
                        {{statusLabel(item)}}
                        <img [src]="statusIcon(item)">
                    </span>
                    <span class="status-label" style="color: #313840bd;">
                        Ver Detalhes
                        <i class="fas fa-chevron-right"></i>
                    </span>
                    <!-- <button (click)="acaoBotao(item)" *ngIf="item.situacaoId > 0 && item.situacaoId !== 6" class="action-button">{{labelBotao(item)}}</button> -->
                </div>
            </div>
        </div>

</div>
